import { Fragment } from 'react';

interface MultilineTextProps {
  text: string;
}

export function MultilineText({ text }: MultilineTextProps) {
  return (
    <>
      {text.split(/\r\n|\r|\n/).map((line, index, lines) => (
        <Fragment key={index}>
          {line}
          {index < lines.length - 1 && <br />}
        </Fragment>
      ))}
    </>
  );
}
